module.exports = __webpack_public_path__ + "static/media/Used Cat Motor Graders - Toromont Cat.4bab9eee.jpg";